import { withRBAC } from "../../../rbac";
import { SalaryStructureCreate } from "./Create";
import { SalaryStructureEdit } from "./Edit";
import { SalaryStructureList } from "./List";

export const salaryStructures = {
  list: withRBAC(SalaryStructureList, "view_hr"),
  create: withRBAC(SalaryStructureCreate, "manage_hr"),
  edit: withRBAC(SalaryStructureEdit, "manage_hr"),
};
